module.exports = __webpack_public_path__ + "img/hdoc.c8c5383f.png";